module.exports = __webpack_public_path__ + "static/img/app-slide-show2.7b344d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/client/cjpublishing-orlkis-wgm/images/app-slide-show2.png
// module id = /rC7
// module chunks = 44